import { P0, S, abs, core, moodK, scaleAt, sq } from '../../geometry';

export const fringe = {
  name: 'Fringe',
  colors: ['#C46A3E', '#2F9E5B'],
  draw(m, t) {
    let A = 1.5,
      sp = 1.5,
      L = 12,
      pose = P0();
    if (m === 'happy') {
      A = 4;
      sp = 8;
      L = 13;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: a slow wave keeps passing through the strands.
    if (m === 'thinking') {
      A = 4.5;
      sp = 3;
    }
    if (m === 'talking') {
      A = 2.5;
      sp = 6;
    }
    if (m === 'surprised') {
      L = -12;
      A = 0.6;
      sp = 24;
    }
    if (m === 'paused') {
      L = 19;
      A = 0.8;
      sp = 0.6;
    }
    const bar = [
      [24, 31],
      [50, 24],
      [76, 31],
    ];
    const strands = [...Array(7)].map((_, k) => {
      const x = 30 + (k * 40) / 6,
        yb = 31 - 7 * (1 - Math.pow((x - 50) / 26, 2)) + 1,
        sw = A * S(t * sp - k * 0.8);
      return {
        c: 'b',
        pts: [
          [x, yb],
          [x + sw * 0.4, yb + L * 0.5],
          [x + sw, yb + L],
        ],
      };
    });
    return {
      strokes: [{ c: 'a', pts: bar }, ...strands],
      eyes: { x: 50, y: 57 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(
      core(scaleAt(sq(50, 60, 22, 19, 3), 50, 60, moodK(m, t)))
    );
    return f;
  },
};
